/*
 *   Does Literally nothing, useful to handle consistent-return eslint rule
 * */
export default _ => _;
